import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import React, { FC, useEffect, useState } from 'react';
import { PricingItem } from 'src/pages-all/user/user-profile/my-pricing/components/PricingItem';
import {
  DEFAULT_PRESELECTED_LESSONUNIT_COUNT,
  pricingModelList,
} from 'src/pages-all/user/user-profile/my-pricing/my-pricing.const';
import styled from 'styled-components';

const StyledContentBox = styled.div<{maxMobileLarge: boolean, minDesktop: boolean}>`
  display: flex;
  gap: 10px;
  justify-content: ${({ minDesktop }) => minDesktop ? 'space-between' : 'center'};
  flex-wrap: wrap;
  text-align: ${({ maxMobileLarge }) => maxMobileLarge ? 'center' : ''};
`;

export const PricePackages: FC<{ listener: (lessonUnitCount: number) => void }> = ({ listener }) => {
  //if set new default selectedPackage you may need to change DEFAULT_PRESELECTED_LESSONUNIT_COUNT too
  const [selectedPackage, setSelectedPackage] = useState<number>(1);
  const { maxMobileLarge, minDesktop } = useBreakpoints();

  useEffect(() => {
    listener(DEFAULT_PRESELECTED_LESSONUNIT_COUNT);
  }, []);
  return (
    <>
      <StyledContentBox maxMobileLarge={maxMobileLarge} minDesktop={minDesktop}>
        {
          pricingModelList.map((pricingModel, i) =>
            <PricingItem key={i} pricingModel={pricingModel} listener={listener} selected={selectedPackage === i} onClick={() => setSelectedPackage(i)}/>
          )
        }
      </StyledContentBox>
    </>
  );
};
